export const ListQueryKey = 'fullExchangeCheckIns';
export const DetailQueryKey = 'fullExchangeCheckIn';

export const Urls = {
  selectUrl: '/fullExchangeCheckin/list',
  updateUrl: '/fullExchangeCheckin/update',
  deleteUrl: '/fullExchangeCheckin/delete',
  createUrl: '/fullExchangeCheckin/create',
  detailUrl: '/fullExchangeCheckin/detail',
};
